'use strict';

var isVariantLabel = require('./is-variant-label.cjs');
var variantProps = require('./variant-props.cjs');

const numVariantProps = variantProps.variantProps.length;
function getVariantContext(visualElement) {
    if (!visualElement)
        return undefined;
    if (!visualElement.isControllingVariants) {
        const context = visualElement.parent
            ? getVariantContext(visualElement.parent) || {}
            : {};
        if (visualElement.props.initial !== undefined) {
            context.initial = visualElement.props.initial;
        }
        return context;
    }
    const context = {};
    for (let i = 0; i < numVariantProps; i++) {
        const name = variantProps.variantProps[i];
        const prop = visualElement.props[name];
        if (isVariantLabel.isVariantLabel(prop) || prop === false) {
            context[name] = prop;
        }
    }
    return context;
}

exports.getVariantContext = getVariantContext;
//# sourceMappingURL=get-variant-context.cjs.map
